var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.0034C1 5.92829 5.92487 1.00342 12 1.00342C18.0751 1.00342 23 5.92829 23 12.0034C23 18.0786 18.0751 23.0034 12 23.0034C5.92487 23.0034 1 18.0786 1 12.0034ZM12 3.00342C7.02944 3.00342 3 7.03286 3 12.0034C3 16.974 7.02944 21.0034 12 21.0034C16.9706 21.0034 21 16.974 21 12.0034C21 7.03286 16.9706 3.00342 12 3.00342Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.889 9.41763C16.2795 9.80816 16.2795 10.4413 15.889 10.8318L11.6463 15.0745C11.2558 15.465 10.6226 15.465 10.2321 15.0745L8.1108 12.9532C7.72028 12.5626 7.72027 11.9295 8.1108 11.539C8.50132 11.1484 9.13449 11.1484 9.52501 11.539L10.9392 12.9532L14.4748 9.41763C14.8653 9.02711 15.4984 9.02711 15.889 9.41763Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ad80da12bf418473c980adbd6e6330a4.svg";
export { ForwardRef as ReactComponent };